import React from 'react';
import { Typography, Skeleton } from '@mui/material';
import { useGetTaskCategoryQuery } from '@/features/engagements/engagementsApi';

export const DataGridTaskCategory = ({ categoryId }) => {
	const { data: taskCategory, isLoading } = useGetTaskCategoryQuery(categoryId, {
		skip: !categoryId,
	});

	if (isLoading) {
		return <Skeleton variant='text' width='6em' />;
	}

	return <Typography variant='inherit'>{taskCategory?.label ?? '-'}</Typography>;
};
